<template>
  <section class="tcl">
    <div class="tcl-header">
      <h1>Tipos de cambio</h1>
      <div class="tcl-filtros">
        <input v-model="desde" type="date" class="tcl-input" @change="cargar" />
        <span>a</span>
        <input v-model="hasta" type="date" class="tcl-input" @change="cargar" />
        <button v-if="puedeEditar" class="tcl-btn tcl-btn--primary" @click="abrirNuevo">
          <i class="ri-add-line"></i> Cargar TC
        </button>
      </div>
    </div>

    <p class="tcl-nota">
      Un registro por día. Los montos del dashboard se valorizan con el tipo de
      <b>compra</b>. Los días sin publicación (fines de semana y feriados) usan
      el último disponible.
    </p>

    <table class="tcl-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th class="text-right">Compra</th>
          <th class="text-right">Venta</th>
          <th class="text-center">Fuente</th>
          <th>Última actualización</th>
          <th v-if="puedeEditar"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in items" :key="r.id">
          <td>{{ r.fecha }}</td>
          <td class="text-right">{{ num(r.compra) }}</td>
          <td class="text-right">{{ num(r.venta) }}</td>
          <td class="text-center">
            <span class="tcl-badge" :class="`tcl-badge--${r.fuente.toLowerCase()}`">{{ r.fuente }}</span>
          </td>
          <td class="tcl-fecha">{{ (r.updated_at || r.created_at || '').slice(0, 16) }}</td>
          <td v-if="puedeEditar" class="text-right">
            <button class="tcl-link" @click="abrirEdicion(r)">Corregir</button>
          </td>
        </tr>
        <tr v-if="!items.length && !cargando">
          <td :colspan="puedeEditar ? 6 : 5" class="tcl-empty">
            No hay tipos de cambio cargados todavía.
          </td>
        </tr>
      </tbody>
    </table>

    <exchange-rate-modal v-model="modal" :rate="seleccionado" @saved="cargar" />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { ExchangeRateService } from "@/core/services";
import ExchangeRateModal from "@/core/components/ExchangeRateModal.vue";
import { hoyLocal, hoyLocalMenosMeses } from "@/core/utils/fecha";

export default {
  name: "ExchangeRateList",
  components: { ExchangeRateModal },
  data() {
    return {
      items: [],
      desde: hoyLocalMenosMeses(1),
      hasta: hoyLocal(),
      cargando: false,
      modal: false,
      seleccionado: null,
    };
  },
  computed: {
    // El backend es quien decide; acá solo se evita ofrecer un botón que
    // devolvería 403. isAdmin es SUPER_ADMINISTRATOR o ADMINISTRATOR, los dos
    // roles que el grupo admin del API deja escribir.
    ...mapGetters({ puedeEditar: "auth/isAdmin" }),
  },
  methods: {
    num(v) {
      return Number(v || 0).toFixed(4);
    },
    abrirNuevo() {
      this.seleccionado = null;
      this.modal = true;
    },
    abrirEdicion(r) {
      this.seleccionado = r;
      this.modal = true;
    },
    async cargar() {
      this.cargando = true;
      try {
        const r = await ExchangeRateService.list({ desde: this.desde, hasta: this.hasta, page: 0, size: 100 });
        this.items = r.payload || [];
      } catch (e) {
        console.error("Error al listar tipos de cambio", e);
        this.items = [];
      } finally {
        this.cargando = false;
      }
    },
  },
  mounted() {
    this.cargar();
  },
};
</script>

<style lang="stylus" scoped>
.tcl
  padding 16px 24px 40px

.tcl-header
  display flex
  flex-wrap wrap
  justify-content space-between
  align-items center
  gap 10px
  h1
    font-size 1.15rem
    font-weight 600
    margin 0

.tcl-filtros
  display flex
  align-items center
  gap 6px
  font-size 0.82rem

.tcl-input
  border 1px solid #d1d5db
  border-radius 6px
  padding 4px 8px
  font-size 0.82rem

.tcl-btn
  border 1px solid #d1d5db
  background #fff
  border-radius 6px
  padding 5px 12px
  font-size 0.82rem
  cursor pointer
  &--primary
    background #365EFF
    border-color #365EFF
    color #fff

.tcl-nota
  font-size 0.78rem
  color #6b7280
  margin 10px 0 14px
  max-width 70ch

.tcl-table
  width 100%
  background #fff
  border 1px solid #e5e7eb
  border-radius 8px
  border-collapse collapse
  font-size 0.84rem
  th, td
    padding 7px 10px
    border-bottom 1px solid #f3f4f6
  th
    text-align left
    font-weight 600
    color #6b7280

.tcl-fecha
  color #9ca3af
  font-size 0.78rem

.tcl-badge
  font-size 0.7rem
  padding 2px 7px
  border-radius 4px
  font-weight 600
  background #e5e7eb
  color #374151
  &--sunat
    background #d1fae5
    color #065f46
  &--manual
    background #fef3c7
    color #92400e

.tcl-link
  border none
  background none
  color #365EFF
  cursor pointer
  font-size 0.82rem

.tcl-empty
  text-align center
  color #9ca3af
  padding 22px 0
</style>
